import fetchJsonp from "fetch-jsonp";

export default class VKservice {
  _apiBase = "https://api.vk.com/method/";
  _apiVersion = "v=5.52";

  getResource = async (url, token) => {
    const res = await fetchJsonp(
      `${this._apiBase}${url}&access_token=${token}&${this._apiVersion}`,
      {
        method: "GET",
        dataType: "JSONP",
        mode: "cors"
      }
    );
    if (!res.ok) {
      throw new Error(`Could not fetch ${res.status}`);
    }
    const response = await res.json();
    if (!!response.error) {
      if (response.error.error_code === 5) {
        delete localStorage.token;
        window.location.reload();
        alert("Неверный токен");
      } else {
        alert(response.error.error_msg);
      }
    } else {
      return response;
    }
  };

  getFriends = async token => {
    const res = await this.getResource(
      "friends.search?count=60&fields=photo_100&",
      token
    );
    return res.response.items;
  };

  getPhotos = async (id, token, offset) => {
    let active = `owner_id=${id}&`;
    if (!id) {
      active = null;
    }
    if (!offset) {
      offset = 0;
    }

    const res = await fetchJsonp(`${this._apiBase}photos.getAll?count=60&${active}offset=${offset}&&access_token=${token}&${this._apiVersion}`);
   
    const pht = await res.json()
    console.log("Photos response", pht);
    return pht.response
  };
}
